
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"12","height":"12","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.23 1H3.307a.77.77 0 00-.769.77v1.538c0 .425.344.769.77.769h6.922a.77.77 0 00.77-.77V1.77A.77.77 0 0010.23 1z","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M6.77 7.924v-.77a1.538 1.538 0 00-1.54-1.538H2.539A1.538 1.538 0 011 4.078v-.77a.77.77 0 01.77-.769h.768","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M5.615 10.999V8.69a.77.77 0 01.77-.77h.769a.77.77 0 01.769.77V11","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    